<template>
  <ThemedComponent
    v-if="menu"
    path="Page"
    :component-name="menu.componentName"
  />
</template>

<script setup lang="ts">
import { LANGUAGES } from '~/constants/language'

definePageMeta({
  alias: LANGUAGES.map(lang => `/${lang}/:slug`),
})

const { menu } = await useResolvedMenuRoute()
</script>
